export default () =>
  import(/* webpackChunkName: 'coffee/update-mobile' */ './UpdateMobile');
